import React from "react";
import ContributorHomePage from '../components/ContributorHomePage/ContributorHomePage';

function ContributorMainPage() {
  return <ContributorHomePage />;
}

export default ContributorMainPage;
